import { getFunctions, httpsCallable } from 'firebase/functions';
import { Timestamp } from 'firebase/firestore';
import { GameListEntry, HltbInfo } from './types';

interface HltbLookupResult {
  id: number | null;
  main: number | null;
}

// searchTitle overrides what is sent to HLTB when the stored title
// doesn't match their naming.
export const lookupHltb = async (
  title: string,
  year: number,
  searchTitle?: string
): Promise<HltbInfo> => {
  const call = httpsCallable<
    { title: string; year: number | null; searchTitle?: string },
    HltbLookupResult
  >(getFunctions(), 'hltbLookup');
  const { data } = await call({
    title,
    year: year || null,
    ...(searchTitle && { searchTitle }),
  });

  return { id: data.id, main: data.main, checkedAt: Timestamp.now() };
};

// Accepts a pasted game URL (howlongtobeat.com/game/12345) or a bare id.
export const parseHltbId = (input: string): number | null => {
  const value = input.trim();
  const match = value.match(/\/game\/(\d+)/) || value.match(/^(\d+)$/);
  return match ? Number(match[1]) : null;
};

export const hltbSearchUrl = (title: string) =>
  `https://howlongtobeat.com/?q=${encodeURIComponent(title)}`;

export const hltbUrl = (game: GameListEntry) =>
  game.hltb?.id
    ? `https://howlongtobeat.com/game/${game.hltb.id}`
    : hltbSearchUrl(game.title);

export const formatHltb = (game: GameListEntry) =>
  game.hltb?.main ? `HLTB - ${game.hltb.main}hrs` : 'HLTB';
